import { useEffect, useState } from 'react';
import { MarketingProjectService } from '../services/MarketingProjectService';
import type { MarketingProject } from '../types/project';

export function useMarketingProjects(enabled = true): MarketingProject[] {
  const [projects, setProjects] = useState<MarketingProject[]>([]);

  useEffect(() => {
    if (!enabled) {
      setProjects([]);
      return undefined;
    }

    let cancelled = false;

    const load = async () => {
      try {
        const rows = await MarketingProjectService.listForFilters();
        if (!cancelled) {
          setProjects(rows);
        }
      } catch {
        if (!cancelled) {
          setProjects([]);
        }
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return projects;
}
